<template>
    <!-- 刷卡记录  -->
    <div class="formBox">
      <!--员工基本信息 -->
      <FormTitle titleText="基本信息"/>
     <Form  ref="formValidate" :model="formItem"  :label-width="150" label-position="left"  style="margin-top:  25px;">
        <div style="margin-bottom: 15px" class="rowAllBox">
            <Row type="flex" justify="space-between">
              <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                <FormItem label="员工工号" >
                  <Input disabled placeholder="" v-model="formItem.empCode">
                  </Input>
                </FormItem>
              </Col>
              <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                <FormItem label="姓名">
                  <Input disabled v-model="formItem.applyName"></Input>
                </FormItem>
              </Col>
              <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                <FormItem label="职位">
                  <Input disabled v-model="formItem.applyPositionName" />
                </FormItem>
              </Col>
            </Row>
            <!-- <Row type="flex" justify="space-between">
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="公司" >
                    <Input disabled placeholder="" v-model="formItem.apply_orgsname2">
                    </Input>
                  </FormItem>
                </Col>
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="地区">
                    <Input disabled v-model="formItem.apply_orgsname4"></Input>
                  </FormItem>
                </Col>
                <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
                  <FormItem label="部门">
                    <Input disabled v-model="formItem.apply_orgsname5" />
                  </FormItem>
                </Col>
              </Row> -->
              <div class="personnelMatters-button" style="margin-top: 30px; margin-bottom: 30px">
                    <Checkbox :disabled="getQueryVariable('history')==1"  true-value="1" false-value="0" v-model="formItem.punch_in ">补刷卡</Checkbox>
                    <Checkbox :disabled="getQueryVariable('history')==1"  style="margin-left: 100px;" true-value="1" false-value="0" v-model="formItem.card_correction">刷卡修正</Checkbox>
            </div>
        </div>
     </Form>
     <div style="margin-top: 15px;">
        <FormTitle titleText="原始刷卡记录"/>
        <Form  ref="formValidate" :model="formItem"  :label-width="150" label-position="left" >
            <Table border :columns="columns1" :data="data1">
            </Table>
        </Form>
     </div>
     <div style="margin-top: 15px;" v-if="formItem.punch_in=='1'"> 
        <FormTitle titleText="补刷卡"/>
        <Form  ref="formValidate" :model="formItem"  :label-width="150" label-position="left" >
            <Table border :columns="columns2" :data="data2" >
                <template slot-scope="{ row, index }" slot="slot" >
                    <div>
                      <Icon
                        style="color: red"
                        type="md-close"
                        @click="getQueryVariable('history') ==1 ? '' : deletePunchIn(row,index)"
                      />
                    </div>
                  </template>
            </Table>
            <div class="addT" @click="addBuCard" v-if="!getQueryVariable('history')">
                <Icon type="md-add" style="font-size: 20px;margin-right: 8px;" />
                新增
            </div>
        </Form>
     </div>
     <div style="margin-top: 15px;" v-if="formItem.card_correction=='1'">
        <FormTitle titleText="刷卡修正"/>
        <Form  ref="formValidate" :model="formItem"  :label-width="150" label-position="left" >
            <Table border :columns="columns3" :data="data3">
            </Table>
            <div class="addT" @click="selectEditCard()" v-if="!getQueryVariable('history')">
                <Icon type="md-add" style="font-size: 20px;margin-right: 8px;" />
                选择需修正资料
            </div>
        </Form>
     </div>
     <!-- 保存和提交 -->
    <div style="margin-top: 30px;display:flex;justify-content:center">
        <Button class="applyBtnRight" v-if="!isHistory" @click="importCG">导入草稿</Button>
        <Button class="applyBtnRight" v-if="!isHistory" @click="saveCG">保存草稿</Button>
        <Button class="applyBtnRight" v-if="!getQueryVariable('history')" type="primary" @click="submitCard">提交</Button>
        <Button class="applyBtnRight" type="primary" @click="returnPage" >返回</Button>
    </div>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1"/>
    <j2-DraftPop ref="cgPop"/>
    <!-- 新增补刷卡 -->
    <Modal v-model="showAddCard" title="新增补刷卡" width="600px">
        <Form :model="formInline" inline :label-width="50" label-position="left">
        <Row>
            <Col span="17" :offset="4">
                <FormItem label="日期：" :label-width="120">
                    <DatePicker type="date" @on-change="getScheduling" style="width: 200px" v-model="formInline.card_date" ></DatePicker>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="17" :offset="4">
                <FormItem label="排班：" :label-width="120">
                    <Input type="text" v-model="formInline.sort_class"  disabled placeholder="" style="width: 200px"></Input>
                </FormItem>
            </Col>
        </Row>
          <Row>
            <Col span="17" :offset="4">
                <FormItem label="補刷卡別：" :label-width="120">
                   <Select clearable style="width: 200px" v-model="formInline.card_type">
                       <Option v-for="(item, index) in ShuaKaBie" :value="item.code" :key="index">{{item.value}}</Option>
                   </Select>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="17" :offset="4">
                <FormItem label="补刷卡时间" :label-width="120">
                    <Time-picker type="time" format="HH:mm" placeholder="" v-model="formInline.card_time" style="width: 200px"></Time-picker>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="17" :offset="4">
                <FormItem label="补刷卡原因" :label-width="120">
                    <Input type="textarea" v-model="formInline.card_comment" placeholder="" style="width: 200px"></Input>
                </FormItem>
            </Col>
        </Row>
        </Form>
        <div slot="footer">
            <Button @click="addPunchIn">确定</Button>
            <Button @click="closeAddCard">取消</Button>
        </div>
      </Modal>
      <!-- 选择修正资料 -->
      <Modal v-model="showEditCard" title="选择需修正资料" width="600px">
        <Form :model="formValidate" inline :label-width="50" label-position="left">
            <FormItem label="日期：" :label-width="120">
                <Input type="text" v-model="formValidate.card_date" placeholder="" style="width: 200px"></Input>
            </FormItem>
            <Button type="primary" >查询</Button>
            <Table border ref="myTable"  :columns="columns5" :data="data5">
                <template slot-scope="{ row, index }" slot="action">
                  <Button
                    type="primary"
                    size="small"
                    style="margin-right: 5px"
                    @click="select1(row, index)"
                    >选择</Button>
                </template>
              </Table>
              <Page style="margin-top: 20px; text-align: right" />
        </Form>
        <div slot="footer"></div>
      </Modal>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <div v-if="getQueryVariable('history')">
        <!-- 审批历史 -->
        <FormTitle titleText="审批历史" style="margin-top: 30px" />
        <Table border :columns="columns6" :data="data6" class="titleDistance">
        </Table>
      </div>
    </div>
  </template>
  <script>
  import axios from "axios";
  import DateUtil from "../../../util/DateUtil";
  export default {
    data() {
        return{
            date: new DateUtil(),
            formItem:{},
            formInline:{},
            pageInfo:{
                pageNo:1,
                pageSize:10
            },
            total:0,
            isHistory:false,
            history:{},
            instanceId:"",
            data1:[],
            data2:[],
            data3:[],
            data4:[],
            data5:[],
            spinShow:false,
            ShuaKaBie:[
                {
                    code : 1,
                    value : "上班"
                },
                {
                    code : 2,
                    value : "下班"
                },
                {
                    code : 3,
                    value : "加班上班"
                },
                {
                    code : 4,
                    value : "加班下班"
                },
            ],
            showAddCard:false,
            showEditCard:false,
            formValidate:{},
            data6:[],
        }
    },
    computed:{
        columns1() {
        return [
          {
            title: "日期",
            key: "card_date",
            align: "center",
          },
          {
            title: "排班",
            key: "sort_class",
            align: "center",
          },
          {
            title: "刷卡别",
            key: "card_type",
            align: "center",
          },
          {
            title: "刷卡时间",
            key: "card_time",
            align: "center",
          },
        ];
      },
      columns2() {
        return [
          {
            title: "日期",
            key: "card_date",
            align: "center",
            render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.card_date, "YYYY-MM-DD")
                    );
                },
          },
          {
            title: "排班",
            key: "sort_class",
            align: "center",
          },
          {
            title: "补刷卡别",
            key: "card_type",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                this.ShuaKaBie.filter(item => item.code==params.row.card_type).map(res => res.value)
                );
            },
          },
          {
            title: "补刷卡时间",
            key: "card_time",
            align: "center",
          },
          {
            title: "补刷卡原因",
            key: "card_comment",
            align: "center",
          },
          {
            title: "删除",
            align: "center",
            slot:"slot"
          },
        ];
      },
      columns3() {
        return [
          {
            title: "日期",
            key: "card_date",
            align: "center",
          },
          {
            title: "排班",
            key: "sort_class",
            align: "center",
          },
          {
            title: "刷卡别",
            key: "card_type",
            align: "center",
          },
          {
            title: "刷卡时间",
            key: "card_time",
            align: "center",
          },
          {
            title: "状态",
            key: "card_status",
            align: "center",
          },
          {
            title: "删除",
            align: "center",
            slot:"slot"
          },
        ];
      },
      columns6(){
      return [
        {
          title: this.$t('审批流名称'),
          key: "stepName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('实际审批者'),
          key: "userName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('审批时间'),
          key: "time",
          align: "center",
          width:"280",
          render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
                    );
                },
        },
        {
          title: this.$t('审批状态'),
          key: "status",
          align: "center",
          width:"280",
          render: (h, params) => {
                    return h(
                    "span",
                    params.row.status == "0" ? "通过" : params.row.status == "1" ? "驳回" : ""
                    );
                },
        },
        {
          title: this.$t('审批意见'),
          key: "message",
          align: "center",
          width:"435",
        },
      ]
  },
      columns5() {
        return [
          {
            title: "操作",
            align: "center",
            slot:"action"
          },
          {
            title: "日期",
            key: "card_date",
            align: "center",
          },
          {
            title: "排班",
            key: "sort_class",
            align: "center",
          },
          {
            title: "刷卡别",
            key: "card_type",
            align: "center",
          },
          {
            title: "刷卡时间",
            key: "card_time",
            align: "center",
          },
        ];
      },
    },
    created() {
        
        if(this.getQueryVariable('history')==1){
           this.getApprovalInfo()
           this.isHistory=true
        }else{
            // 获取当前登录人信息
            this.getLoginInfo()
        }
    },
    methods:{
      //获取当前排班
      getScheduling(){
          let obj = {
              serialnumber:this.formItem.serialnumber,
              attDate: this.formInline.card_date
          }
          axios.post('/work/getScheduling',obj).then(res =>{
            this.$set(this.formInline,'sort_class',res)
          })
        },
        //打开草稿列表
        importCG() {
          this.$refs.cgTem.getInternation()
          //草稿type 操作人
            this.$refs.cgTem.popShow('SK01',JSON.parse(sessionStorage.getItem('userInfo')).userId)
        },
        //保存草稿
        saveCG() {
          this.$refs.cgPop.getInternation()
          //草稿type 草稿内容
          this.$refs.cgPop.popShow('SK01',{formItem: this.formItem,data1:this.data1,data2:this.data2,data3:this.data3})
        },
        //导入草稿数据到页面
        getCGDa1(row) {
          var obj = JSON.parse(row.draftContent)
          this.formItem = obj.formItem
          this.data1 = obj.data1
          this.data2 = obj.data2
          this.data3 = obj.data3
        },
        getApprovalInfo(){
            let Obj = {
                instanceId : this.getQueryVariable('instanceId')
            }
            axios.post("/Card/selectCardApproval", Obj).then((res) => {
               this.formItem= res.approvalCard
               this.data2 = res.cardPunchInList
               this.data6=res.logMap
            })
        },
        submitCard(){
            this.$Modal.confirm({
                title: this.$notice('submission'),
                content: "",
                onOk: () => {
                    this.handleSubmit()
                },
                onCancel: () => {},
             });
        },
        handleSubmit(){
            let arr=[{
                objData1 :{
                    ...this.formItem,
                    apply_user_id:JSON.parse(window.sessionStorage.getItem("userInfo")).userId, 
                    apply_serialnumber:JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber, 
                    apply_name:JSON.parse(window.sessionStorage.getItem("userInfo")).userName,
                    apply_position_name : this.formItem.applyPositionName
                },
                stringData1: "SK01",
                type: "B31",
            }]
            this.spinShow =true 
            axios.post("/process/execute", arr).then((res) => {
               if(res){
                   this.instanceId = res[0]
                   this.spinShow=false
                   this.$router.push("/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27");
                   this.insertCardOther();
               }
            })
        },
        insertCardOther(){
            let time = '';
            this.data2.forEach((item) => {
                time = '';
                time = item.card_date ? this.date.dateVal(new Date(item.card_date), "YYYY-MM-DD") : '';
                item.card_time = time + ' ' + item.card_time
                item.card_time = this.date.dateVal(new Date(item.card_time), "YYYY-MM-DD HH:mm:ss");
            })
            console.log(this.data2)
             let Obj={
                applyCardPunchIn : this.data2,
                instanceId : this.instanceId
            }
            axios.post("/Card/insertCardOther", Obj).then((res) => {
                console.log(res)
            })
        },
        deletePunchIn(row,index){
            this.data2.splice(index, 1);
        },
        addPunchIn(){
            this.data2.push(this.formInline);
            this.showAddCard = false;
            this.formInline = {}
        },
        closeAddCard(){
            this.showAddCard=false
            this.formInline = {}
        },
        getLoginInfo(){
            let Obj={
                serialnumber : JSON.parse(sessionStorage.getItem('userInfo')).serialnumber,
                optionName:['YESORNO'] 
            }
            axios.post("/Exit/selectEmployeeInfo", Obj).then((res) => {
              this.formItem.empCode = res.data[0].empCode;
                this.formItem.apply_serialnumber = res.data[0].serialnumber;
                this.formItem.applyName = res.data[0].userName
                this.formItem.applyPositionName = res.data[0].positionName
                this.formItem.apply_orgsname2 =res.data[0].orgsname2
                this.formItem.apply_orgsname4 = res.data[0].orgsname4
                this.formItem.apply_orgsname5 =res.data[0].orgsname5
                this.formItem.serialnumber =res.data[0].serialnumber
                this.$forceUpdate()
            })
        },
        selectEditCard(){
            this.showEditCard=true
        },
        addBuCard(){
            this.showAddCard=true
        },
        returnPage() {
            //1审批 0 申请
            if (this.getQueryVariable("history") == 1) {
                this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
            } else {
              this.$router.go(-1);
            }
        },
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                return pair[1];
                }
            }
            return false;
        },
    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .formBox {
    width: 97%;
    margin: auto;
    background: white;
    padding-bottom: 30px;
    border-radius: 10px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .rowBox {
    line-height: 35px;
    font-size: 14px;
    box-sizing: border-box;
    margin-top: 10px;
  }
  .rowAllBox {
    width: 97%;
    margin: auto;
  }

  .width {
    width: 180px;
  }
  .personnelMatters-button {
    display: flex;
    justify-content: center;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/process/Apply/cardApply.vue